// Mükerrer talep koruması: işlem anahtarı (Idempotency-Key) yardımcıları
import { toast } from 'sonner';

export const newIdemKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID()
  : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`);

// Sekme kapanana kadar (sayfa yenilense de) aynı anahtar korunur; başarıda silinir
export const storedIdemKey = (name) => {
  let k = sessionStorage.getItem(name);
  if (!k) { k = newIdemKey(); sessionStorage.setItem(name, k); }
  return k;
};
export const clearIdemKey = (name) => sessionStorage.removeItem(name);
export const idemConfig = (key) => ({ headers: { 'Idempotency-Key': key } });

// 409 mükerrer işlem yanıtlarını kullanıcıya anlaşılır göster; işlendiyse true
export const handleIdemConflict = (error, navigate) => {
  const d = error?.response?.status === 409 ? error.response.data?.detail : null;
  if (!d || typeof d !== 'object' || !String(d.code || '').startsWith('idempotency_')) return false;
  if (d.code === 'idempotency_mismatch' && d.permit_id) {
    toast.warning(`${d.message} (Talep No: ${d.request_number})`, {
      duration: 12000,
      action: { label: 'İlk talebi aç', onClick: () => navigate(`/work-permits/${d.permit_id}/edit`) },
    });
  } else {
    toast.warning(d.message, { duration: 6000 });
  }
  return true;
};
